export const customStyles = {
    control: (provided,state) => ({
      ...provided,
      backgroundColor: 'white',
      width: "100%",
      borderColor: state.isFocused ? '#5F5F5F' : '#5F5F5F',
      color: '#fff',
      boxShadow: 'none',
      borderRadius: '8px',
      padding: '6px 8px',
      fontSize: '16px',
      '&:hover': {
        borderColor: state.isFocused ? '#5F5F5F' : '',
      }
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      color: '#fff',
      fontSize: '16px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#007BFF' : state.isFocused ? 'white' : 'white',
      color: state.isSelected ? '#fff' : '#5F5F5F',
      fontSize: '18px',
      '&:hover': {
        backgroundColor: state.isSelected ? '#007BFF' : 'lightblue',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#5F5F5F',
      fontFamiliy: "Helvetica",
      fontSize: '18px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#5F5F5F',
      fontSize: '18px',
    }),
    input: (provided) => ({
      ...provided,
      color: '#5F5F5F',
      fontSize: '18px',
      width: "100%",
    }),
  };
  